<!-- 楽天用ので現在使われていないため修正しません -->
<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col :cols="isMobile ? 12 : 8">
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile }"
          v-html="$t('campaign.title') + ' (' + advertiser.advertiserName + ')'"
        ></h1>
      </v-col>
      <v-col :cols="isMobile ? '6' : '4'" class="text-right">
        <v-btn color="light-blue darken-1 text-white" @click="clickSubmissionConfirmationCampaignList()">
          {{ $t('submissionConfirmationCreativeSetting.buttonCampaignDeliveryStatus') }}
        </v-btn>
      </v-col>
      <v-col class="text-right" :cols="isMobile ? 6 : 12">
        <v-btn color="light-blue darken-1 text-white" :disabled="disableSelectDownloadButton" @click="clickCreativeReport()"
          >{{ $t('cpmCreativeReport.buttonToCreativeReport') }}</v-btn
        >
      </v-col>
      <v-col cols="12" v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
      <v-col cols="6" md="4">
        <v-select
          v-model="selectedDeliveryMonth"
          :items="deliveryMonths"
          item-title="label"
          item-value="value"
          :label="$t('commons.form.select.measureperiod.yearmonth-cpm')"
          class="select-digestives"
          @update:modelValue="previewCampaignList()"
          return-object
          variant="underlined"
        ></v-select>
      </v-col>
      <v-col cols="6" md="6">
        <v-text-field v-model="inputCampaignName" label="キャンペーン名" @update:modelValue="previewCampaignList()" variant="underlined"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="campaignPeriodListHeaders"
          :items="campaignList"
          :sort-by="sortBy"
          :sortDesc="false"
          :items-per-page="-1"
          :loading="isSearching"
          :hide-default-header="isMobile"
          :no-data-text="$t('commons.table.no.data.text')"
          hide-default-footer
          class="elevation-3 campaign-list"
          :class="{ mobile: isMobile }"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="text-left break-word-cell caption">
                <v-img v-if="checkDeliveryStatusCondition(props.item) === 'ON'" :src="image_src_on" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                <v-img v-else-if="checkDeliveryStatusCondition(props.item) === 'OFF'" :src="image_src_off" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                <v-img v-else :src="image_src_finish" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                {{ props.item.campaignName }}
              </td>
              <td class="text-center caption">
                <span v-if="props.item.cpxreportType === 'CPM'" @click="clickDeliveryPeriod(props.item.campaignId, props.item.campaignPeriodStartAt, props.item.campaignPeriodEndAt)">
                  <router-link :to="{ path: `` }"
                    >
                    {{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}
                    </router-link
                  >
                </span>
                <span v-if="props.item.cpxreportType === 'CPC'">
                  <router-link :to="{ path: `/cpcReport/${advertiser.agencyId}/${advertiser.advertiserId}/${props.item.campaignPeriodId}` }"
                    >{{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}</router-link
                  >
                </span>
                <span v-if="props.item.cpxreportType === 'CPA'">
                  <router-link :to="{ path: `/cpaReport/${advertiser.agencyId}/${advertiser.advertiserId}/${props.item.campaignPeriodId}` }"
                    >{{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}</router-link
                  >
                </span>
                <span v-else />
              </td>
              <td class="text-center caption">{{ props.item.cpxreportType }}</td>
              <td class="text-right caption">{{ number_format_yen(props.item.periodGoalBudget) }}</td>
              <td class="text-right caption">{{ digestive_format(props.item.digestiveAmount) }}</td>
            </tr>
            <tr v-else>
              <v-row align="center" justify-center @click="clickToReport(props.item.cpxreportType, props.item.campaignId, props.item.campaignPeriodStartAt, props.item.campaignPeriodEndAt, props.item.campaignPeriodId)">
                <v-col cols="11">
                  <ul class="flex-content body-2">
                    <li class="flex-item word-break" :data-label="$t('campaign.headers.campaignName')">
                      <v-img v-if="checkDeliveryStatusCondition(props.item) === 'ON'" :src="image_src_on" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                      <v-img v-else-if="checkDeliveryStatusCondition(props.item) === 'OFF'" :src="image_src_off" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                      <v-img v-else :src="image_src_finish" width="10" height="10" style="display:inline-block;margin-right:5px;"></v-img>
                      {{ props.item.campaignName }}
                    </li>
                    <li class="flex-item" :data-label="$t('campaign.headers.deliveryPeriod')">
                      {{ props.item.campaignPeriodStartAt }} - {{ props.item.campaignPeriodEndAt }}
                    </li>
                    <li class="flex-item" :data-label="$t('campaign.headers.cpxreportType')">{{ props.item.cpxreportType }}</li>
                    <li class="flex-item" :data-label="$t('campaign.headers.periodGoalBudget')">{{ number_format_yen(props.item.periodGoalBudget) }}</li>
                    <li class="flex-item" :data-label="$t('campaign.headers.digestiveAmount')">{{ digestive_format(props.item.digestiveAmount) }}</li>
                  </ul>
                </v-col>
              </v-row>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { useFormatters } from '../plugins/format';

export default {
  name: 'CampaignList',
  props: ['advertiserId'],
  mixins: [{
    methods: {
      ...useFormatters()
    }
  }],
  data: function () {
    return {
      selectedDeliveryMonth: {},
      deliveryMonths: [],
      inputCampaignName: '',
      disableSelectDownloadButton: true,
      sortBy: [{ key: 'campaignPeriod', order: 'asc'}],
      isSearching: true,
      campaignPeriodListHeaders: [
        {
          title: this.$t('campaign.headers.campaignName'),
          align: 'center',
          sortable: true,
          key: 'campaignName',
          width: '45%'
        },
        {
          title: this.$t('campaign.headers.deliveryPeriod'),
          align: 'center',
          sortable: true,
          key: 'campaignPeriod',
          width: '25%'
        },
        {
          title: this.$t('campaign.headers.cpxreportType'),
          align: 'center',
          sortable: true,
          key: 'cpxreportType',
          width: '10%'
        },
        {
          title: this.$t('campaign.headers.periodGoalBudget'),
          align: 'center',
          sortable: true,
          key: 'periodGoalBudget',
          width: '10%'
        },
        {
          title: this.$t('campaign.headers.digestiveAmount'),
          align: 'center',
          sortable: true,
          key: 'digestiveAmount',
          width: '10%'
        }
      ],
      infoResult: {},
      advertiser: {},
      agency: {},
      campaignList: [],
      isMobile: false,
      agencyId: undefined,
      errorMessage: undefined,
      menuItems: [{ title: this.$t('campaignPeriod.reportDownload.menuTitle.campaignPeriod'), click: 'campaignPeriod' }],
      image_src_on: require(`../../public/imgs/status_on.png`),
      image_src_off: require(`../../public/imgs/status_off.png`),
      image_src_finish: require(`../../public/imgs/status_finish.png`)
    }
  },
  methods: {
    ...mapActions('deliveryMonth', ['getMonthAllList', 'setSelectedDeliveryMonth']),
    ...mapActions('campaignList', ['getCampaignList']),
    ...mapActions('bundleDownload', ['getDownload']),
    initialize: function () {
      // カレンダーの初期化とリストの初期表示
      this.getMonthAllList().then((result) => {
        this.deliveryMonths = result
        const params = 'deliveryMonth/selectedDeliveryMonth'
        // 当月を指定する（全てが存在するから配列２）
        var defaultDeliveryMonth = result[2]
        if (this.$route.query.yearMonth !== undefined) {
          for (var i in result) {
            if (this.$route.query.yearMonth === result[i].value) {
              defaultDeliveryMonth = result[i]
            }
          }
        } else if (this.$store.getters[params] !== undefined) {
          defaultDeliveryMonth = this.$store.getters[params]
        }
        this.selectedDeliveryMonth = defaultDeliveryMonth
        // this.previewPeriodList()
        this.previewCampaignList()
      })
    },
    // previewPeriodList: function () {
    previewCampaignList: function () {
      const jwtToken = this.$store.getters['auth/jwtToken']
      const deliveryMonth = this.selectedDeliveryMonth.value
      this.setSelectedDeliveryMonth(this.selectedDeliveryMonth)
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      const campaignName = this.inputCampaignName
      this.isSearching = true
      // URLにパラメータを付与
      var url = location.href
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'))
      }
      this.$router.replace({
        query: { yearMonth: deliveryMonth }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });
      // this.getPeriodList({
      this.getCampaignList({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        deliveryMonth: deliveryMonth,
        campaignName: campaignName,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.isSearching = false
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.infoResult = {}
            this.campaignList = []
            this.advertiser = {}
            this.agency = {}
            return
          }
          this.infoResult = result
          this.advertiser = result.advertiser
          this.agency = result.agency
          this.campaignList = result.campaignList
          this.agencyId = result.advertiser.agencyId
        })
        .catch((err) => {
          this.isSearching = false
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
    },
    clickCreativeReport: function () {
      let campaignIds = new Set()
      for (const campaign of this.campaignList) {
        campaignIds.add(campaign.campaignId)
      }
      const dateFormat = 'YYYYMMDD'
      const cIds = Array.from(campaignIds).join(',')
      const start = moment(this.selectedDeliveryMonth.value + '01', dateFormat)
      const end = moment(start).endOf('month')
      this.$router.push({
        path: `/cpmCreativeReportList/${this.agencyId}/${this.advertiserId}`,
        query: {
          cIds: cIds,
          from: start.format(dateFormat),
          to: end.format(dateFormat)
        }
      })
    },
    clickDeliveryPeriod: function (campaignId, campaignPeriodStart, campaignPeriodEnd) {
      const dateFormat = 'YYYYMMDD'
      const campaignPeriodStartAt = moment(new Date(campaignPeriodStart)).format(dateFormat)
      const campaignPeriodEndAt = moment(new Date(campaignPeriodEnd)).format(dateFormat)
      this.$router.push({
        name: 'CampaignReport',
        params:
        {
          'agencyId': this.agencyId,
          'privateCode': process.env.ProjectCode,
          'advertiserId': this.advertiserId,
          'campaignId': campaignId
        },
        query:
        {
          'from': campaignPeriodStartAt,
          'to': campaignPeriodEndAt
        }
      })
    },
    clickToReport: function(cpxreportType, campaignId, startAt, endAt, campaignPeriodId) {
      switch (cpxreportType) {
        case 'CPM':
          this.clickDeliveryPeriod(campaignId, startAt, endAt)
          break
        case 'CPA':
          this.$router.push('/cpaReport/' + this.agencyId + '/' + this.advertiserId + '/' + campaignPeriodId)
          break
        case 'CPC':
          this.$router.push('/cpcReport/' + this.agencyId + '/' + this.advertiserId + '/' + campaignPeriodId)
          break
      }
    },
    checkDeliveryStatusCondition: function(campaign) {
      const ON = 'ON'
      const OFF = 'OFF'
      const FINISH = 'FINISH'
      if (campaign.campaignStatusFlag) {
        if (campaign.matchCampaignPeriodFlag) {
          return ON
        } else {
          return FINISH
        }
      } else {
        return OFF
      }
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    clickSubmissionConfirmationCampaignList: function () {
      this.$router.push(`/campaignLanding/counts/${this.agencyId}/${this.advertiserId}`)
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next()
  },
  mounted: function () {
    this.initialize()
  },
  computed: {},
  watch: {
    campaignList: function (campaignPeriodIds) {
      // 計測期間が「全て」又はデータが存在しない場合は、ダウンロードボタンは非活性
      if (campaignPeriodIds[0] === undefined || this.selectedDeliveryMonth.value === '000000') {
        this.disableSelectDownloadButton = true
      } else {
        this.disableSelectDownloadButton = false
      }
    }
  }
}
</script>
<style scoped>
.campaign-list .break-word-cell {
  max-width: 500px;
  word-wrap: break-word;
}
.mobile table.v-table tr ul li:before {
  content: attr(data-label);
  padding-right: 0.5em;
  text-align: left;
  display: block;
  color: #999;
}
</style>